/**
 * Menvora PDP Analytics — clicks, scroll depth, zonas, dead clicks en imágenes.
 * Requiere menvora-analytics-core.js + window.MENVORA_PDP (config desde Liquid).
 *
 * API pública: window.MenvoraPdp.track(name, params)
 * Declarativo: data-menvora-track="zone_id" en cualquier nodo dentro del root PDP.
 */
(function () {
  if (window.__menvoraPdpAnalyticsV1) return;
  window.__menvoraPdpAnalyticsV1 = true;

  var analytics = window.MenvoraAnalytics;
  if (!analytics || typeof analytics.track !== 'function') {
    console.warn('[MenvoraPdp] MenvoraAnalytics no cargado; eventos omitidos.');
    return;
  }

  var track = analytics.track;
  var sanitize = analytics.sanitize;

  var cfg = window.MENVORA_PDP || {};
  var rootSelector = cfg.rootSelector || '[data-menvora-pdp-root]';
  var scrollMarks = cfg.scrollMarks || [25, 50, 75, 90, 100];
  var zoneViewThreshold = typeof cfg.zoneViewThreshold === 'number' ? cfg.zoneViewThreshold : 0.5;

  var state = {
    root: null,
    startedAt: Date.now(),
    maxScrollPct: 0,
    scrollSent: {},
    zonesSeen: {},
    deadClickDedupe: {},
    firstClickSent: false,
    rageClickLog: [],
  };

  function basePayload(extra) {
    var p = {
      product_handle: sanitize(cfg.productHandle || 'unknown'),
      template: sanitize(cfg.template || 'product'),
      view: sanitize(cfg.view || 'default'),
      lp: sanitize(cfg.lp || ''),
      path: sanitize((location.pathname || '').slice(0, 80)),
    };
    if (extra) {
      for (var k in extra) {
        if (Object.prototype.hasOwnProperty.call(extra, k)) p[k] = extra[k];
      }
    }
    return p;
  }

  function publicTrack(name, params, options) {
    track(name, basePayload(params), options);
  }

  function rootEl() {
    if (state.root && document.contains(state.root)) return state.root;
    state.root = document.querySelector(rootSelector);
    return state.root;
  }

  function scrollDepthPct() {
    var doc = document.documentElement;
    var scrollTop = window.scrollY !== undefined ? window.scrollY : doc.scrollTop || 0;
    var viewport = window.innerHeight || doc.clientHeight || 0;
    var scrollHeight = Math.max(doc.scrollHeight, document.body ? document.body.scrollHeight : 0);
    if (scrollHeight <= viewport) return 100;
    var pct = Math.round(((scrollTop + viewport) / scrollHeight) * 100);
    return Math.min(100, Math.max(0, pct));
  }

  function scrollTop() {
    return window.scrollY !== undefined ? window.scrollY : document.documentElement.scrollTop || 0;
  }

  function coordsPayload(ev) {
    var vpW = window.innerWidth || 1;
    var vpH = window.innerHeight || 1;
    var doc = document.documentElement;
    var scrollHeight = Math.max(doc.scrollHeight, document.body ? document.body.scrollHeight : 0) || 1;
    return {
      vp_x: Math.round((ev.clientX / vpW) * 100),
      vp_y: Math.round((ev.clientY / vpH) * 100),
      page_y_pct: Math.round(((scrollTop() + ev.clientY) / scrollHeight) * 100),
    };
  }

  function findTrackedZone(el) {
    if (!el || !el.closest) return null;
    var root = rootEl();
    var node = el.closest('[data-menvora-track]');
    if (node && (!root || root.contains(node))) {
      return sanitize(node.getAttribute('data-menvora-track') || 'unknown');
    }
    return inferZone(el);
  }

  function inferZone(el) {
    if (!el || !el.closest) return 'unknown';
    var checks = [
      ['sticky_bar', '[data-sticky-panel], .sticky-buy-bar, [data-product-scroll-controls]'],
      ['buy_box', '.product-form, .product__info-wrapper, #ProductInfo-' + (cfg.sectionId || '')],
      ['gallery', 'media-gallery, .product__media-wrapper, .product__media-list'],
      ['faq', 'details.accordion, .accordion, .collapsible-content'],
      ['reviews', '[data-menvora-reviews-track], .menvora-ads-reviews'],
      ['description', '.product__description, [id^="ProductDescription-"]'],
      ['lp_stack', '.product__media-list--ads-stack'],
      ['trust', '.menvora-atf-trust, .menvora-ads-offer-bar'],
      ['price', '.price, .product__price'],
      ['variants', '.product-form__input, variant-selects, [id^="ProductVariants-"]'],
    ];
    for (var i = 0; i < checks.length; i++) {
      if (el.closest(checks[i][1])) return checks[i][0];
    }
    return 'page';
  }

  function elementHint(el) {
    if (!el) return 'unknown';
    var tag = (el.tagName || 'node').toLowerCase();
    var role = el.getAttribute && el.getAttribute('role');
    var id = el.id ? String(el.id).slice(0, 40) : '';
    var cls = el.className && typeof el.className === 'string' ? el.className.split(/\s+/).slice(0, 2).join('.') : '';
    var alt = el.getAttribute && el.getAttribute('alt');
    var aria = el.getAttribute && el.getAttribute('aria-label');
    var text = (el.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 40);
    var hint = tag;
    if (role) hint += ':role=' + role;
    if (id) hint += '#' + sanitize(id);
    else if (cls) hint += '.' + sanitize(cls);
    if (alt) hint += '|alt=' + sanitize(alt);
    else if (aria) hint += '|aria=' + sanitize(aria);
    else if (text) hint += '|txt=' + sanitize(text);
    return sanitize(hint);
  }

  function lpSliceFromEl(el) {
    if (!el || !el.closest) return '';
    var item = el.closest('.product__media-item');
    if (item) {
      var slug = item.getAttribute('data-lp-slug');
      if (slug) return sanitize(slug);
    }
    var img = el.closest('img, picture');
    if (!img) return '';
    var target = img.tagName === 'IMG' ? img : img.querySelector('img');
    if (!target) return '';
    var alt = (target.getAttribute('alt') || '').trim();
    var match = alt.match(/^lp[-_]([a-z0-9_-]+)/i);
    if (match) return sanitize(match[1]);
    item = target.closest('.product__media-item');
    if (item) {
      var idx = item.getAttribute('data-media-position') || item.dataset.mediaPosition;
      if (idx) return sanitize('slice_' + idx);
    }
    return '';
  }

  function isInteractive(el) {
    if (!el || !el.closest) return false;
    var node = el.closest('a[href], button, input, select, textarea, summary, label, [role="button"], [tabindex]:not([tabindex="-1"])');
    if (!node) return false;
    if (node.matches && node.matches('a[href]') && node.getAttribute('href') === '#') return false;
    return true;
  }

  function isMediaClick(el) {
    if (!el || !el.closest) return false;
    return !!el.closest('.product__media-item img, .product__media-item picture, .product-media-container img, modal-opener');
  }

  function shouldDeadClick(el) {
    if (isInteractive(el)) return false;
    if (isMediaClick(el)) return true;
    var tag = (el.tagName || '').toLowerCase();
    if (/^(img|picture|video|svg)$/.test(tag)) return true;
    if (tag === 'span' || tag === 'p' || tag === 'li') {
      return !el.closest('a, button, summary');
    }
    return false;
  }

  function clickPayload(ev, el) {
    var zone = findTrackedZone(el);
    var payload = Object.assign(
      {
        zone: zone,
        target: elementHint(el),
        lp_slice: lpSliceFromEl(el),
      },
      coordsPayload(ev)
    );
    return payload;
  }

  var RAGE_WINDOW_MS = 2000;
  var RAGE_THRESHOLD = 3;

  function checkRageClick(ev, payload) {
    var now = Date.now();
    var key = payload.vp_x + '|' + payload.vp_y + '|' + payload.zone;
    // Purgar entradas viejas
    state.rageClickLog = state.rageClickLog.filter(function (e) { return now - e.t < RAGE_WINDOW_MS; });
    state.rageClickLog.push({ t: now, key: key });
    var sameSpot = state.rageClickLog.filter(function (e) { return e.key === key; });
    if (sameSpot.length >= RAGE_THRESHOLD) {
      publicTrack('PdpRageClick', Object.assign({}, payload, { count: sameSpot.length }));
      // Limpiar para no disparar en cada click subsiguiente
      state.rageClickLog = state.rageClickLog.filter(function (e) { return e.key !== key; });
    }
  }

  function onClick(ev) {
    var root = rootEl();
    if (!root || !root.contains(ev.target)) return;

    var el = ev.target;
    var payload = clickPayload(ev, el);

    // PdpTimeToClick: primer click desde carga
    if (!state.firstClickSent) {
      state.firstClickSent = true;
      publicTrack('PdpTimeToClick', Object.assign({}, payload, {
        dwell_ms: Date.now() - state.startedAt,
      }));
    }

    publicTrack('PdpClick', payload);
    checkRageClick(ev, payload);

    if (isMediaClick(el)) {
      publicTrack('PdpImageClick', Object.assign({}, payload, { interactive: isInteractive(el) ? 1 : 0 }));
    }

    if (shouldDeadClick(el)) {
      var dedupeKey = payload.zone + '|' + payload.target + '|' + payload.vp_x + '|' + payload.vp_y;
      var now = Date.now();
      if (state.deadClickDedupe[dedupeKey] && now - state.deadClickDedupe[dedupeKey] < 600) return;
      state.deadClickDedupe[dedupeKey] = now;
      publicTrack(
        'PdpDeadClick',
        Object.assign({}, payload, {
          reason: isMediaClick(el) ? 'media_non_interactive' : 'non_interactive_element',
        })
      );
    }
  }

  function onScroll() {
    var pct = scrollDepthPct();
    if (pct > state.maxScrollPct) state.maxScrollPct = pct;
    for (var i = 0; i < scrollMarks.length; i++) {
      var mark = scrollMarks[i];
      if (pct >= mark && !state.scrollSent[mark]) {
        state.scrollSent[mark] = true;
        publicTrack('PdpScrollDepth', { depth_pct: mark, max_pct: pct });
      }
    }
  }

  function observeZones() {
    var root = rootEl();
    if (!root || typeof IntersectionObserver !== 'function') return;

    var nodes = root.querySelectorAll('[data-menvora-track]');
    if (!nodes.length) return;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || entry.intersectionRatio < zoneViewThreshold) return;
          var zone = sanitize(entry.target.getAttribute('data-menvora-track') || 'unknown');
          if (state.zonesSeen[zone]) return;
          state.zonesSeen[zone] = true;
          publicTrack('PdpZoneView', {
            zone: zone,
            visible_pct: Math.round(entry.intersectionRatio * 100),
          });
        });
      },
      { threshold: [zoneViewThreshold, 0.75, 1] }
    );

    Array.prototype.forEach.call(nodes, function (node) {
      io.observe(node);
    });
  }

  function observeLpSlices() {
    var root = rootEl();
    if (!root || typeof IntersectionObserver !== 'function') return;
    var imgs = root.querySelectorAll(
      '.product__media-list--ads-stack img[alt^="lp-"], .product__media-list--ads-stack img[alt^="LP-"], .product__media-list--ads-stack .product__media-item[data-lp-slug] img'
    );
    if (!imgs.length) return;

    var seen = {};
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || entry.intersectionRatio < 0.4) return;
          var alt = entry.target.getAttribute('alt') || '';
          var match = alt.match(/^lp[-_]([a-z0-9_-]+)/i);
          var item = entry.target.closest('.product__media-item');
          var fromData = item && item.getAttribute('data-lp-slug');
          var slice = fromData ? sanitize(fromData) : match ? sanitize(match[1]) : sanitize(alt.slice(0, 40));
          if (seen[slice]) return;
          seen[slice] = true;
          publicTrack('PdpLpSliceView', { lp_slice: slice, alt: sanitize(alt.slice(0, 60)) });
        });
      },
      { threshold: [0.4, 0.75] }
    );

    Array.prototype.forEach.call(imgs, function (img) {
      io.observe(img);
    });
  }

  function bindAccordions() {
    var root = rootEl();
    if (!root) return;
    root.addEventListener(
      'toggle',
      function (ev) {
        var details = ev.target;
        if (!details || details.tagName !== 'DETAILS') return;
        var summary = details.querySelector('summary');
        var heading = summary ? sanitize((summary.textContent || '').trim().slice(0, 60)) : 'faq';
        publicTrack('PdpAccordion', {
          zone: findTrackedZone(details),
          heading: heading,
          action: details.open ? 'open' : 'close',
        });
      },
      true
    );
  }

  function sendScrollSummary(reason) {
    publicTrack(
      'PdpScrollMax',
      {
        depth_pct: state.maxScrollPct,
        dwell_ms: Date.now() - state.startedAt,
        reason: sanitize(reason || 'pagehide'),
      },
      { transport_type: 'beacon' }
    );
  }

  function init() {
    if (!rootEl()) return;

    publicTrack('PdpView', {
      media_count: cfg.mediaCount || 0,
      ads_stacked: cfg.adsStacked ? 1 : 0,
    });

    document.addEventListener('click', onClick, true);
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    window.addEventListener('pagehide', function () {
      sendScrollSummary('pagehide');
    });
    window.addEventListener('pageshow', function (ev) {
      if (ev.persisted) {
        state.maxScrollPct = 0;
        state.scrollSent = {};
        state.zonesSeen = {};
        state.startedAt = Date.now();
        state.firstClickSent = false;
        state.rageClickLog = [];
        publicTrack('PdpView', { reason: 'pageshow_bfcache' });
        // Re-enganchar observers para zonas/slices que ya son visibles
        observeZones();
        observeLpSlices();
      }
    });

    observeZones();
    observeLpSlices();
    bindAccordions();
    onScroll();
  }

  window.MenvoraPdp = {
    track: publicTrack,
    refresh: function () {
      state.root = null;
      init();
    },
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
